import { camelCase } from 'lodash';
import { BooleanFilterOperationType } from 'components/organisms/tasks/filters/boolean';
import { Operation } from 'components/organisms/tasks/filters/operations';
import { pascalCase } from '../../pascal-case';
import { unreachable } from '../../unreachable';
const toApiFormat = (filter)=>{
    const type = camelCase(filter.type);
    switch(filter.type){
        case BooleanFilterOperationType.IsEmpty:
        case BooleanFilterOperationType.IsNotEmpty:
            return {
                operation: type,
                sourceType: filter.field.sourceType
            };
        case BooleanFilterOperationType.IsTrue:
            return {
                operation: Operation.Value,
                value: 'true',
                sourceType: filter.field.sourceType
            };
        case BooleanFilterOperationType.IsFalse:
            return {
                operation: Operation.Value,
                value: 'false',
                sourceType: filter.field.sourceType
            };
        default:
            return unreachable(filter.type);
    }
};
const parse = ({ operation, value }, field)=>{
    switch(operation){
        case Operation.IsEmpty:
        case Operation.IsNotEmpty:
            return {
                field,
                type: pascalCase(operation)
            };
        case Operation.Value:
            return {
                field,
                type: value === 'true' ? BooleanFilterOperationType.IsTrue : BooleanFilterOperationType.IsFalse
            };
        default:
            return unreachable(operation);
    }
};
export const BooleanFilter = {
    toApiFormat,
    parse
};
